module.exports = __webpack_public_path__ + "static/media/twitterbannermobil.dbba266b.png";